import axios from 'axios'
import { message, Modal } from 'ant-design-vue'
import router from '@/router'
import route from '@/router'
import eventsBus from '@/utils/eventsBus'
import { getFileErrorText } from '@/utils/eventSourceError'

let modal = null
class HTTPRequest {
  constructor(config) {
    this.axiosInstance = axios.create(config)
    this.interceptors = config.interceptors

    this.axiosInstance.interceptors.request.use(
      this.interceptors?.requestInterceptor,
      this.interceptors?.requestInterceptorCatch
    )
    this.axiosInstance.interceptors.response.use(
      this.interceptors?.responseInterceptor,
      this.interceptors?.responseInterceptorCatch
    )

    this.axiosInstance.interceptors.request.use(
      (config) => {
        return config
      },
      (err) => {
        router.push({
          name: 'pageStatus',
          params: {
            code: 'networkError'
          }
        })
        return Promise.reject(err)
      }
    )
    this.axiosInstance.interceptors.response.use(
      (res) => {
        // 处理响应数据
        if (res.headers['emp-type'] == 'error') {
          message.error({
            content: getFileErrorText(res.headers['emp-type']),
            key: 'errorMessage'
          })
        } else {
          if (res.config.responseType == 'blob') {
            let filename = null
            if (res.headers['content-disposition']) {
              const filenameEncoded = res.headers['content-disposition']
                .split('filename=')[1]
                .replace(/"/g, '') // 去掉可能存在的引号
              filename = decodeURIComponent(filenameEncoded)
            }
            // URL 解码
            return {
              data: res.data,
              filename
            }
          } else {
            return res.data
          }
        }
      },
      (err) => {
        router.push({
          name: 'pageStatus',
          params: {
            code: 'networkError'
          }
        })
        return Promise.reject(err)
      }
    )
  }

  request(config) {
    return new Promise((resolve) => {
      if (config.interceptors?.requestInterceptor) {
        config = config.interceptors.requestInterceptor(config)
      }
      this.axiosInstance
        .request(config)
        .then((res) => {
          // 1.单个请求对数据的处理
          if (config.interceptors?.responseInterceptor) {
            res = config.interceptors.responseInterceptor(res)
          }
          //处理错误码
          if ([604, 607, 11009].includes(res?.code)) {
            // 处理团队不存在，解散的异常
            if (!modal) {
              modal = Modal.warning({
                title: '异常警告',
                centered: true,
                closable: false,
                content: res.msg || '团队异常',
                okText: '去个人空间',
                onOk() {
                  console.log('OK')
                  modal.destroy()
                  modal = null
                  setTimeout(() => {
                    eventsBus.emit('goUserCenter')
                  }, 500)
                }
              })
            }
          } else if (
            // 处理未登录
            [401, 10016, 10017].includes(res?.code) &&
            (route.name !== 'userAgreement' || route.name !== 'privacyAgreement')
          ) {
            router.push('/login')
          } else if ([18011].includes(res?.code)) {
            // 处理数智员工已过期或被移除
            router.push({ name: 'Home' })
          } else if (/^5\d{2}$/.test(String(res?.code))) {
            // 处理5开头的服务器错误
            router.push({
              name: 'pageStatus',
              params: {
                code: 'serverError'
              }
            })
          }

          if (res?.isError) {
            // 这个错误吗不弹出错误信息
            if (![20055].includes(res?.code)) {
              message.error({
                content: res.msg,
                key: 'errorMessage'
              })
            }
            resolve({
              code: res.code,
              msg: res.msg
            })
          } else {
            resolve(res)
          }
        })
        .catch((err) => {
          resolve({})
          return err
        })
    })
  }

  get(config) {
    return this.request({ ...config, method: 'GET' })
  }

  delete(config) {
    return this.request({ ...config, method: 'DELETE' })
  }

  post(config) {
    return this.request({ ...config, method: 'POST' })
  }

  put(config) {
    return this.request({ ...config, method: 'put' })
  }
}

export default HTTPRequest
